import { createActions } from 'redux-actions';

export const graphActions = createActions({
    GET_GRAPH: (queryID, baseQueryID, params, days) => ({ queryID, baseQueryID, params, days }),
    SET_UI:    (value, path) => ({ value, path }),
}, { prefix: 'APL_GRAPH' });
